export default {"src":"/_next/static/media/Purple Booth Logo-01.f744b19e.svg","height":929,"width":1385};